module.exports = __webpack_public_path__ + "img/Progress-Report-2-mobile.93e07d35.png";